"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateEligibilityTestResults = void 0;
const common_1 = require("@finley-technologies/common");
const updateEligibilityTestResults = ({ eligibilityTestResults, receivable, }) => {
    // **** Eligibility and concentration result handling *****
    receivable.eligibilityStatuses.forEach(({ eligibilityCriteriaKey, eligibilityStatus }) => {
        const eligibilityTestResult = eligibilityTestResults.get(eligibilityCriteriaKey);
        // Assert that this exists - it is unexpected if it was not present in the original eligibility criteria used to create the map
        (0, common_1.finleyAssert)(eligibilityTestResult, `Expected eligibility criteria ${eligibilityCriteriaKey} to exist in top-level eligibility criteria set, but it was not found for customer receivable ID ${receivable.externalReceivableId}`);
        // The only event that is currently used for eligibility kickouts is INELIGIBLE
        switch (eligibilityStatus) {
            case 'INELIGIBLE':
                eligibilityTestResult.eligibilityReduction +=
                    receivable.eligibilityFields.eligibilityKickout;
                break;
            case 'ELIGIBLE':
            case 'INELIGIBLE_WAIVED':
                break;
            default:
                (0, common_1.finleyAssertUnreachable)(eligibilityStatus);
        }
    });
};
exports.updateEligibilityTestResults = updateEligibilityTestResults;
//# sourceMappingURL=eligibility.js.map